<div *ngIf="loading" class="overlay">
    <div class="spinner"></div>
  </div>
  
     
<div class="row">
    <p class="error">{{error_message}}</p>
</div>

<form #form="ngForm">
    <blockquote>
        <h5 class="headings">INFORMATION ON DIRECTORS</h5>
    </blockquote>
    <div class="form-body">
        <div  *ngFor="let director of directors; let i = index" class="input-row">
            <input placeholder="Name" name="director-name" [(ngModel)]="director.strName" (ngModelChange)="resetErrorMessage()" [ngModelOptions]="{standalone: true}" [readonly]="isViewOnly" >
            <input placeholder="Position" name="director-pos" [(ngModel)]="director.strJobPosition" (ngModelChange)="resetErrorMessage()" [ngModelOptions]="{standalone: true}" [readonly]="isViewOnly">
            <button *ngIf="!isViewOnly && i > 0" class="delete-btn" (click)="removeDirector(i)"><i class="material-icons icon-inline">clear</i></button>
        </div>
        <div class="btn-container">
            <button *ngIf="!isViewOnly" class="add-btn" (click)="addDirectorRow()">+</button> 
        </div>
    </div>
    

    <blockquote>
        <h5 class="headings">PERSONS AUTHORISED TO SIGN BIDS, OFFERS & CONTRACTS </h5>
    </blockquote>
    <div class="form-body">
        <div  *ngFor="let authsignatory of authsignatories; let i = index" class="input-row">
            <input placeholder="Name" name="auth-name" (ngModelChange)="resetErrorMessage()" [(ngModel)]="authsignatory.strName" [ngModelOptions]="{standalone: true}" [readonly]="isViewOnly">
            <input placeholder="Position" name="auth-pos" (ngModelChange)="resetErrorMessage()" [(ngModel)]="authsignatory.strJobPosition" [ngModelOptions]="{standalone: true}" [readonly]="isViewOnly">
            <input placeholder="Email Address" name="auth-email" (ngModelChange)="resetErrorMessage()" [(ngModel)]="authsignatory.strEmail" [ngModelOptions]="{standalone: true}" [readonly]="isViewOnly" #emailInput required (ngModelChange)="validateEmail(emailInput.value)">
            <input placeholder="Telephone" name="auth-phone" (ngModelChange)="resetErrorMessage()" [(ngModel)]="authsignatory.strPhoneNumber" [ngModelOptions]="{standalone: true}" [readonly]="isViewOnly" #phoneInput (input)="validatePhoneNumber(phoneInput.value)">
            <button *ngIf="!isViewOnly && i > 0" class="delete-btn" (click)="removeAuthRow(i)"><i class="material-icons icon-inline">clear</i></button>
        </div>
        <div class="btn-container">
            <button *ngIf="!isViewOnly" class="add-btn" (click)="addAuthRow()">+</button> 
        </div>
    </div>


    <blockquote>
        <h5 class="headings">AFFILIATED/HOLDING SUBSIDARY COMPANIES</h5>
    </blockquote>
    <div class="form-body">
        <!-- EDIT MODE: always show form -->
        <div *ngIf="!isViewOnly">
            <div *ngFor="let subs of subsidaries; let i = index" class="input-row">
            <input placeholder="Company/Subsidary Name" name="subs-name"
                    [(ngModel)]="subs.strName" (ngModelChange)="resetErrorMessage()" [ngModelOptions]="{standalone: true}">
            <input placeholder="Address" name="subs-address"
                    [(ngModel)]="subs.strAddress" (ngModelChange)="resetErrorMessage()" [ngModelOptions]="{standalone: true}">
            <input placeholder="Name of Affiliation" name="subs-affil"
                    [(ngModel)]="subs.strAffiliation" (ngModelChange)="resetErrorMessage()" [ngModelOptions]="{standalone: true}">
            <button *ngIf="i > 0" class="delete-btn" (click)="removeAffilRow(i)">
                <i class="material-icons icon-inline">clear</i>
            </button>
            </div>
        </div>

        <!-- VIEW-ONLY MODE: show populated data or "None" -->
        <div *ngIf="isViewOnly">
            <ng-container *ngIf="hasSubsidariesWithName; else noSubs">
            <div *ngFor="let subs of subsidaries" class="input-row">
                <input placeholder="Company/Subsidary Name" [value]="subs.strName" readonly>
                <input placeholder="Address" [value]="subs.strAddress" readonly>
                <input placeholder="Name of Affiliation" [value]="subs.strAffiliation" readonly>
            </div>
            </ng-container>
            <ng-template #noSubs>
            <p style="font-style: italic; margin-left: 20px;">None</p>
            </ng-template>
        </div>

        <!-- Add button (edit mode only) -->
        <div class="btn-container" *ngIf="!isViewOnly">
            <button class="add-btn" (click)="addAffilRow()">+</button>
        </div>
    </div>

</form>